export enum OtlRuleDataLimitationName {
  SINGLE_TRANSACTION = 'SingleTransaction',
  DAILY = 'Daily',
  MONTHLY = 'Monthly',
}

export const isOtlRuleDataLimitationName = (val: unknown): val is OtlRuleDataLimitationName =>
  typeof val === 'string' &&
  (val === OtlRuleDataLimitationName.SINGLE_TRANSACTION ||
    val === OtlRuleDataLimitationName.DAILY ||
    val === OtlRuleDataLimitationName.MONTHLY);

export enum CreditCardType {
  NONE = 'none',
  AMEX = 'amex',
  DINERS = 'diners',
  DISCOVER = 'discover',
  ISRACARD = 'isracard',
  MASTERCARD = 'mastercard',
  VISA = 'visa',
  MAESTRO = 'maestro',
  SWITCH = 'Switch',
  SOLO = 'solo',
  LEUMICARD = 'leumicard',
  CAL = 'cal',
  JCB = 'jcb',
  CARTE_BLANCHE = 'carteBlanche',
  CHINA_UNION_PAY = 'chinaUnionPay',
  LASER = 'laser',
}

export type LimitationData<LimitationName = OtlRuleDataLimitationName> = {
  isActive: boolean;
  value: string;
  limitationName: LimitationName;
};

export type OtlRuleDataLimitation<L = OtlRuleDataLimitationName> = {
  isActive: boolean;
  limitationType: L;
  value: number;
};

export type MoneycardOtlRuleCreditCard = {
  creditcardId: number;
  cardLastDigits: string;
  cardType: CreditCardType;
};

export type MoneycardOtlRuleManagement = {
  otlRule: {
    ruleId: number;
    ruleActive: boolean;
    creditcardId: number;
    limitations: OtlRuleDataLimitation[];
  };
  userCreditcards: MoneycardOtlRuleCreditCard[];
  forceCreditCardForm: boolean;
  hideLimitations: boolean;
};
